import { useSnackbar } from 'utils/hooks/useSnackbar';
import { appVersionUpdates } from 'utils/appVersionUpdates';
import { useEffectOnce, Button, IconButton, styled } from '@beeline.com/bp-design-system';
import React from 'react';
import { useCommonIntl } from 'common/translations/useCommonIntl';

export function useAppVersionHasChanged() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const intl = useCommonIntl();

  useEffectOnce(() => {
    appVersionUpdates.addListener(() => {
      enqueueSnackbar(
        <>
          {intl.newVersionIsAvailable}
          <br />
          {intl.newVersionIsAvailableDesc}
        </>,
        {
          variant: 'info',
          persist: true,
          key: 'newVersionIsAvailable',
          preventDuplicate: true,
          action: (key: string | number) => [
            <StyledButton key="reload" size="small" color="primary" onClick={() => window.location.reload()}>
              {intl.refresh}
            </StyledButton>,
            <StyledIconButton
              iconName="close"
              dataTest="snackbar__notification__button"
              color="active"
              key="dismiss"
              onClick={() => closeSnackbar(key)}
            />
          ]
        }
      );
    });
  });
}

const StyledButton = styled(Button)`
    margin-right: ${({ theme }) => theme.spacingSize.m};
`;

const StyledIconButton = styled(IconButton)`
    && {
      padding: ${({ theme }) => theme.spacingSize.s};
    }
`;
